import React from 'react';

import LoginForm from '../components/forms/LoginForm';
import LoginLayout from '../components/layout/LoginLayout';

const Login = () => {
  return (
    <LoginLayout>
      <LoginForm />
    </LoginLayout>
  );
};

export default Login;
